//@flow
import React from 'react';
import image from '../../../images/office/stella.jpg';

const config = {
  image: image,
  title: 'Why NatureBox for your Office Snacks',
  subtitle: 'At NatureBox, we make it easy for you to provide healthy snacks for your office. We take care of everything so all you and your team have to do is enjoy your snacks.',
  checks: [
    {
      text: 'Never go over budget: Fixed monthly price so you know exactly what you spend on your office snacks.',
    },
    {
      text: 'Dedicated account manager and customer support team.',
    },
    {
      text: 'Variety and Discovery: You choose your snacks with over 50 options to choose from every month, no surprises or unwanted items. Options for a variety of diets.',
    },
    {
      text: 'Simple and sustainable: We package our office snacks in 5lb resealable bags to reduce waste AND we provide the jars, scoops, tongs, and paper trays to serve all of your snacks.',
    },
    {
      text: 'Easy for you: Our dedicated customer support team makes it easy for you to manage your office snacking program. Just let us know when you are 75% through your snacks and we will replenish.',
    },
    {
      text: 'NatureBox Snack Guarantee: If you don’t love it, we’ll replace it.',
    },
  ],
};

const {title, subtitle, checks} = config;

export default function WhyNatureboxSection() {
  const style = {
    backgroundImage: `url(${config.image})`,
  };
  return (
    <div className="why-naturebox-section">
      <div className="inner">
        <div className="left">
          <div className="left-image" style={style} />
        </div>
        <div className="right">
          <div className="top">
            <h2>
              {title}
            </h2>
            <div className="subtitle text-2">
              {subtitle}
            </div>
          </div>
          <div className="checkmarks-container">
            {renderCheckmarks()}
          </div>
        </div>
      </div>
    </div>
  );
}

const renderCheckmarks = () => {
  return (
    <ul className="checkmarks">
      {checks.map((check, index) => (
        <li className="text-3" key={index}>{check.text}</li>
      ))}
    </ul>
  );
};
